import React, { useState, useEffect, useRef } from 'react';
import "./ProductDetails.css";
import { Link, useParams } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import Footer from "../FooterComponent/Footer";
import { useCartContext } from '../../context/addToCart';
import { Spin } from 'antd';
import axios from 'axios';
import { PRODUCT_API_BASE_URL } from '../../services/apiConfig';

// Import Swiper React components and modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { get } from '../../services/ApiRouting';
import { useCurrency } from '../../services/locationService';

const IMAGE_BASE_URL = 'https://1fiveglobal.in/uploads/productsImages/';

const moveDescriptionToTop = (description = '') => {
    const parsedDescription = new DOMParser().parseFromString(
        description,
        'text/html'
    );

    // Normalize non-breaking spaces
    const textNodes = parsedDescription.createTreeWalker(
        parsedDescription.body,
        NodeFilter.SHOW_TEXT
    );

    let textNode = textNodes.nextNode();

    while (textNode) {
        textNode.nodeValue = textNode.nodeValue.replace(/\u00a0/g, ' ');
        textNode = textNodes.nextNode();
    }

    // Find Description paragraph
    const descriptionParagraph = Array.from(
        parsedDescription.body.children
    ).find(
        (element) =>
            element.tagName === 'P' &&
            /^description\s*:/i.test(element.textContent.trim())
    );

    // Move Description before the table/content
    if (descriptionParagraph) {
        parsedDescription.body.insertBefore(
            descriptionParagraph,
            parsedDescription.body.firstChild
        );
    }

    return parsedDescription.body.innerHTML;
};

const ProductDetails = () => {
    const { format } = useCurrency();
    const { product_category, product_subcategory, slug } = useParams();
    const swiperRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [product, setProduct] = useState(null);
    const [productPrice, setProductPrice] = useState(0);
    const [productQuantity, setProductQuantity] = useState(1);
    const [activeIndex, setActiveIndex] = useState(0);
    const [isOutOfStock, setIsOutOfStock] = useState(false);

    // Filtered lists for currently selected color
    const [availableSizes, setAvailableSizes] = useState([]);

    const {
        handleAddCart,
        selectedSize,
        setSelectedSize,
        selectedColor,
        setSelectedColor,
        setSelectedPrice,
        selectedImages,
        setSelectedImages,
        selectedPrice,
        setSelectedProduct,
    } = useCartContext();

    // product data 
    const [productData, setProductData] = useState([]);
    console.log("productData", productData)
    const fetchProductData = async () => {
        setLoading(true);
        try {
            const response = await get(`${PRODUCT_API_BASE_URL}products/cat/${product_category}`);
            setLoading(false);
            setProductData(response?.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProductData();
    }, [product_category]);

    // Fetch Product Data by Slug
    useEffect(() => {
        const fetchProductDetails = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${PRODUCT_API_BASE_URL}products/${slug}`);
                if (response.data?.success) {
                    const productData = response.data.data;
                    console.log("details", productData);
                    setProduct(productData);
                    setSelectedProduct(productData);

                    // Set default selected color
                    const defaultColor = productData.colors?.[0] || null;
                    setSelectedColor(defaultColor);

                    // Filter sizes safely
                    const filteredSizes = defaultColor?.id
                        ? productData.sizes?.filter((s) => s.color_id === defaultColor.id)
                        : productData.sizes || [];

                    // Filter images by color_id, fallback to all images if empty or unmatched
                    let filteredImages = defaultColor?.id
                        ? productData.images?.filter((img) => img.color_id === defaultColor.id)
                        : [];

                    if (!filteredImages || filteredImages.length === 0) {
                        filteredImages = productData.images || [];
                    }

                    setAvailableSizes(filteredSizes.length > 0 ? filteredSizes : productData.sizes || []);
                    setSelectedImages(filteredImages);

                    // Set default size
                    const defaultSize = (filteredSizes.length > 0 ? filteredSizes[0] : productData.sizes?.[0]) || null;
                    setSelectedSize(defaultSize);

                    const currentPrice = defaultSize?.price ? parseFloat(defaultSize.price) : parseFloat(productData.price);
                    setSelectedPrice(currentPrice);
                    setProductPrice(currentPrice);

                    // Stock check: in_stock === 1 and quantity > 0
                    const inStockBool = defaultSize ? (defaultSize.in_stock === 1 && defaultSize.quantity > 0) : true;
                    setIsOutOfStock(!inStockBool);
                } else {
                    setProduct(null);
                }
            } catch (error) {
                console.error("Error fetching product details:", error);
                setProduct(null);
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            fetchProductDetails();
        }
    }, [slug, setSelectedColor, setSelectedImages, setSelectedPrice, setSelectedProduct, setSelectedSize]);

    // Handle Color Switch
    const handleColorSelection = (colorItem) => {
        console.log("Selected Color Object:", colorItem);
        setSelectedColor(colorItem);

        // Filter sizes and images belonging to the selected color
        const filteredSizes = product?.sizes?.filter((s) => s.color_id === colorItem.id) || [];
        let filteredImages = product?.images?.filter((img) => img.color_id === colorItem.id) || [];

        // Fallback to all product images if color-specific array is empty
        if (filteredImages.length === 0) {
            filteredImages = product?.images || [];
        }

        setAvailableSizes(filteredSizes.length > 0 ? filteredSizes : product?.sizes || []);
        setSelectedImages(filteredImages);

        const defaultSize = filteredSizes[0] || product?.sizes?.[0] || null;
        setSelectedSize(defaultSize);
        const newPrice = defaultSize?.price ? parseFloat(defaultSize.price) : parseFloat(product?.price || 0);
        setSelectedPrice(newPrice);
        setProductPrice(newPrice);

        const inStockBool = defaultSize ? (defaultSize.in_stock === 1 && defaultSize.quantity > 0) : true;
        setIsOutOfStock(!inStockBool);

        // Reset slide index and move Swiper to first slide on color change
        setActiveIndex(0);
        if (swiperRef.current) {
            swiperRef.current.slideToLoop(0);
        }
    };

    // Handle Size Selection
    const handleSizeSelection = (sizeItem) => {
        setSelectedSize(sizeItem);
        const price = parseFloat(sizeItem.price);
        setSelectedPrice(price);
        setProductPrice(price);

        const inStockBool = sizeItem.in_stock === 1 && sizeItem.quantity > 0;
        setIsOutOfStock(!inStockBool);
    };

    // Handle thumbnail click to control Swiper slider
    const handleImageChange = (index) => {
        setActiveIndex(index);
        if (swiperRef.current) {
            swiperRef.current.slideToLoop(index);
        }
    };

    // Helper function to dynamically calculate image source URL
    const getImageUrl = (imgObj) => {
        if (!imgObj) return 'https://via.placeholder.com/300x400?text=No+Image';
        const path = typeof imgObj === 'string' ? imgObj : (imgObj.image || imgObj.image_path || '');
        if (!path) return 'https://via.placeholder.com/300x400?text=No+Image';
        return path.startsWith('http') ? path : `${IMAGE_BASE_URL}${path}`;
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <Spin size="large" tip="Loading product..." />
            </div>
        );
    }

    if (!product) {
        return (
            <div style={{ textAlign: 'center', margin: '50px 0' }}>
                <h2>Product not found</h2>
                <Link to="/">Back to Home</Link>
            </div>
        );
    }

    return (
        <>
            <section className='Product-details-section1-main-con'>
                <Spin spinning={loading}>
                    <div className="row">
                        {/* Image Gallery Column */}
                        <div className='col-md-6'>
                            <div className='Product-details-Section-1-Images-Main-Con'>

                                {/* Main Image Swiper */}
                                <div className='Product-details-section-1-Side-Main-Image-con'>
                                    <Swiper
                                        onSwiper={(swiper) => {
                                            swiperRef.current = swiper;
                                        }}
                                        spaceBetween={30}
                                        centeredSlides={true}
                                        autoplay={{
                                            delay: 3000,
                                            disableOnInteraction: false,
                                        }}
                                        loop={selectedImages?.length > 1}
                                        modules={[Autoplay, Pagination, Navigation]}
                                        className="mySwiper"
                                        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                                    >
                                        {selectedImages && selectedImages.length > 0 &&
                                            selectedImages.map((imgObj, index) => (
                                                <SwiperSlide key={imgObj.id || index}>
                                                    <div className='swaiper-product-details-images-main-cond'>
                                                        <LazyLoadImage
                                                            src={getImageUrl(imgObj)}
                                                            alt={`${product.name} ${index + 1}`}
                                                            effect="blur"
                                                        />
                                                    </div>
                                                </SwiperSlide>
                                            ))
                                        }
                                    </Swiper>
                                </div>

                                {/* Thumbnail Images */}
                                <div className='Product-details-section-1-Side-Images-con'>
                                    {selectedImages && selectedImages.length > 0 &&
                                        selectedImages.map((imgObj, index) => (
                                            <div
                                                key={imgObj.id || index}
                                                className={`Product-details-section-1-Side-Image-div ${index === activeIndex ? 'active' : ''}`}
                                                onClick={() => handleImageChange(index)}
                                            >
                                                <LazyLoadImage
                                                    src={getImageUrl(imgObj)}
                                                    alt={`${product.name} ${index + 1}`}
                                                    effect="blur"
                                                />
                                            </div>
                                        ))
                                    }
                                </div>

                            </div>
                        </div>

                        {/* Details & Actions Column */}
                        <div className='col-md-6'>
                            <div className='Product-Details-Section-1-Details-main-con'>
                                <div className='Product-Details-Section-1-Details-navigation-con'>
                                    {/* Breadcrumb Navigation */}
                                    <div className='Product-Details-Section-1-Details-navigation'>
                                        <Link to={`/category/${product.category_name?.toLowerCase()}`}>
                                            <h2 className='Product-details-navigation'>{product.category_name}</h2>
                                        </Link>
                                        <span> / </span>
                                        <Link to={`/product/${product.slug}`}>
                                            <h2 className='Product-details-navigation'>{product.name}</h2>
                                        </Link>
                                    </div>

                                    {/* Title & Price */}
                                    <div className='Product-Details-Section-1-Details-name-price-main-con'>
                                        <div className='Product-Details-Section-1-Details-name'>
                                            <h2>{product.name}</h2>
                                        </div>
                                        <div className='Product-Details-Section-1-Details-Price'>
                                            <h4>{format(selectedPrice)}</h4>
                                        </div>
                                    </div>

                                    {/* Color Swatches */}
                                    <div className='Product-Details-Section-1-Details-color-main-con'>
                                        {product.colors && product.colors.map((colorItem) => (
                                            <div
                                                className={`Product-Details-Section-1-Details-color ${selectedColor && selectedColor.id === colorItem.id ? 'active' : ''}`}
                                                key={colorItem.id}
                                                style={{ backgroundColor: colorItem.code || '#000000' }}
                                                title={colorItem.name}
                                                onClick={() => handleColorSelection(colorItem)}
                                            />
                                        ))}
                                    </div>

                                    {/* Size Options */}
                                    {availableSizes.length > 0 && (
                                        <div className='Product-Details-Section-1-Details-size-main-con'>
                                            {availableSizes.map((sizeItem) => (
                                                <div
                                                    className={`Product-Details-Section-1-Details-size-con ${selectedSize?.id === sizeItem.id ? 'active' : ''} ${sizeItem.in_stock === 0 ? 'disabled' : ''}`}
                                                    key={sizeItem.id}
                                                    onClick={() => handleSizeSelection(sizeItem)}
                                                >
                                                    <h4>{sizeItem.name}</h4>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Add to Cart Button */}
                                    <div className='Product-Details-Section-1-Btn-con'>
                                        <button
                                            onClick={() => handleAddCart({
                                                Quantity: productQuantity,
                                                productprice: productPrice,
                                                product: product,
                                                selectedSize: selectedSize,
                                                selectedColor: selectedColor
                                            })}
                                            disabled={isOutOfStock}
                                            style={{ backgroundColor: isOutOfStock ? "gray" : "" }}
                                        >
                                            {isOutOfStock ? "Out of Stock" : "Add to Cart"}
                                        </button>
                                    </div>

                                    {/* Accordion Details */}
                                    <div className="Product-Details-Section-1-Details-accordion-main-con">
                                        <Accordion defaultActiveKey="0">

                                            <Accordion.Item eventKey="0">

                                                <Accordion.Header>
                                                    Description
                                                </Accordion.Header>

                                                <Accordion.Body>

                                                    <div className="Accordion-Body-content-con">

                                                        {/* Description only */}
                                                        <div
                                                            className="product-description-html"
                                                            dangerouslySetInnerHTML={{
                                                                __html: moveDescriptionToTop(product.description || "")
                                                            }}
                                                        />

                                                    </div>

                                                </Accordion.Body>

                                            </Accordion.Item>

                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Spin>
            </section>

            <section className="Home-product-section-2">
                <div className="Home-product-head-con">
                    <div className="Home-product-head-title-con">
                        <h2>Find Your Match</h2>
                    </div>
                </div>

                <div className="Home-Product-select-card-section-con">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={1}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={{
                            nextEl: ".home-product-slider-next",
                            prevEl: ".home-product-slider-prev",
                        }}
                        breakpoints={{
                            430: { slidesPerView: 2, spaceBetween: 1 },
                            640: { slidesPerView: 2, spaceBetween: 1 },
                            768: { slidesPerView: 3, spaceBetween: 1 },
                            1024: { slidesPerView: 4, spaceBetween: 1 },
                        }}
                        modules={[Pagination, Navigation]}
                        className="mySwiper"
                    >
                        {productData?.map((prodItem, productIndex) => {
                            const primaryImage = getImageUrl(prodItem?.images?.[0]);
                            const secondaryImage = prodItem?.images?.[1]
                                ? getImageUrl(prodItem.images[1])
                                : primaryImage;

                            return (
                                <SwiperSlide key={prodItem.id || productIndex}>
                                    <div className="product-card-main-con">
                                        <Link to={`/${prodItem?.category_slug}/${prodItem?.subcategory_slug}/${prodItem?.slug}`}>
                                            <div className="product-card-body-con">
                                                <div className="product-card-Image-con product-item__image double__image new-product-item__bg">
                                                    <div className="product-item__bg">
                                                        <img
                                                            src={primaryImage}
                                                            alt={prodItem?.name || 'Product'}
                                                        />
                                                    </div>
                                                    <div className="product-item__bg__under">
                                                        <img
                                                            src={secondaryImage}
                                                            alt={prodItem?.name || 'Product Hover'}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="Product-card-details-con">
                                                    <div className="Product-card-details">
                                                        <div className="product-card-product-name">
                                                            <h4>{prodItem.name || prodItem.product_name}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                    <div className="swiper-button-prev home-product-slider-prev"></div>
                    <div className="swiper-button-next home-product-slider-next"></div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default ProductDetails;